import React from "react"
import cx from "classnames"
import PropTypes from "prop-types"
import { MenuButton, MenuPopover, Menu, MenuItems } from "@reach/menu-button"
import Icon from "@kit/design/icon"

const NavButton = ({ title, isExpanded }) => {
  return (
    <MenuButton
      className="nav-hover rounded text-sm mr-1 font-semibold capitalize inline-flex items-center duration-200 focus:outline-none text-black hover:text-black focus:text-black focus:bg-blue-600 focus:bg-warm-white-200"
      style={{ padding: "4px 4px 4px 12px" }}
    >
      {title}
      <Icon
        name="down"
        className={cx("transition-transform ease-in-out", {
          "transform -rotate-180": isExpanded
        })}
        aria-hidden
      />
    </MenuButton>
  )
}

const NavSection = ({ children, title }) => {
  const colCount = length => {
    if (typeof length !== "number") return
    if (length >= 4) {
      return 2
    } else {
      return 1
    }
  }

  return (
    <Menu className="relative">
      {({ isExpanded }) => (
        <>
          <NavButton title={title} isExpanded={isExpanded} />

          <MenuPopover style={{ zIndex: 10000 }}>
            <MenuItems
              className="rounded-lg shadow-lg main-menu-card text-gray-900 mt-2"
              style={{
                gridTemplateColumns: `repeat(${colCount(
                  children?.length
                )}, minmax(340px, 1fr))`
              }}
            >
              {children}
            </MenuItems>
          </MenuPopover>
        </>
      )}
    </Menu>
  )
}

NavSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
}

export default NavSection
